import React from 'react';

import { OrderFormContainer } from '../OrderForm/OrderFormContainer';
import { DonationFailure } from './DonationFailure';
import { DonationForm } from './DonationForm';
import { DonationSuccess } from './DonationSuccess';

export const DonationContainer = () => {
  return (
    <OrderFormContainer
      form={<DonationForm />}
      success={<DonationSuccess />}
      fail={<DonationFailure />}
    />
  );
};
